<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created: function () {
    this.getLevelListFn();
    // 检测小程序传递的token并自动登录
    this.handleMiniToken();
  },
  methods: {
    // 处理小程序传递的token，实现单点登录
    // 由于小程序和H5使用同一个token体系，直接使用token即可
    handleMiniToken: function () {
      // 获取URL参数
      const urlParams = new URLSearchParams(window.location.search);
      const minitoken = urlParams.get('minitoken');
      
      if (!minitoken) {
        return;
      }
      
      // 检查是否已经登录
      const existingToken = sessionStorage.getItem('LOGIN_TOKEN');
      
      // 检查用户信息是否完整
      const existingUserId = this.$store.state.loginUserId;
      const existingIsRegister = this.$store.state.isRegister;
      
      if (existingToken) {
        // 即使已有token，如果用户信息不完整，也需要更新
        if (!existingUserId || existingIsRegister === false || existingIsRegister === null || existingIsRegister === undefined) {
          // 清除URL中的token参数
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
          // 更新token（使用新的minitoken，可能更准确）
          this.$store.commit('set_loginToken', minitoken);
          // 获取用户信息
          this.getUserInfoByToken();
          // 如果当前在登录页，跳转到首页
          if (this.$route.name === 'Login') {
            this.$router.replace({ name: 'Home' });
          }
          return;
        } else {
          // 清除URL中的token参数
          const newUrl = window.location.pathname;
          window.history.replaceState({}, '', newUrl);
          // 如果当前在登录页，跳转到首页
          if (this.$route.name === 'Login') {
            this.$router.replace({ name: 'Home' });
          }
          return;
        }
      }
      
      // 直接使用小程序token（同一个token体系）
      this.$store.commit('set_loginToken', minitoken);
      
      // 设置标记，表示来自小程序环境（用于支付判断）
      sessionStorage.setItem('FROM_MINI_PROGRAM', 'true');
      
      // 清除URL中的token参数，避免泄露
      const newUrl = window.location.pathname;
      window.history.replaceState({}, '', newUrl);
      
      // 获取用户信息（如果需要userid、is_register等信息）
      this.getUserInfoByToken();
      
      // 如果当前在登录页，跳转到首页
      if (this.$route.name === 'Login') {
        this.$router.replace({ name: 'Home' });
      } else if (this.$route.path === '/') {
        // 如果已经在首页，刷新一下确保状态更新
        this.$router.replace({ name: 'Home' });
      }
    },
    // 根据token获取用户信息
    getUserInfoByToken: function () {
      let that = this;
      
      // 先从token中解析userid（如果是JWT token）
      const token = this.$store.state.loginToken;
      if (token) {
        try {
          // JWT token格式：header.payload.signature
          const parts = token.split('.');
          if (parts.length === 3) {
            // 解析payload
            const payload = JSON.parse(decodeURIComponent(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))));
            if (payload.user_id) {
              that.$store.commit('set_loginUserId', payload.user_id);
            }
          }
        } catch (e) {
          // token解析失败，忽略，继续使用接口获取
        }
      }
      
      // 调用获取用户信息的接口，获取is_register等信息
      this.axios.post('/mobile/personalinfo', {})
        .then((response) => {
          if (response.code == 0) {
            // 如果接口返回了userid，设置到store（优先使用接口返回的）
            if (response.userid) {
              that.$store.commit('set_loginUserId', response.userid);
            } else if (response.userinfo && response.userinfo.id) {
              // 如果userinfo中有id，也可以使用
              that.$store.commit('set_loginUserId', response.userinfo.id);
            }
            
            // 判断是否完善信息
            if (response.is_register !== undefined) {
              // 如果接口返回了is_register，直接使用
              that.$store.commit('set_isRegister', response.is_register);
            } else if (response.userinfo) {
              // 如果接口没有返回is_register，根据userinfo判断
              // 如果userinfo有name和identity_number，说明已完善信息
              if (response.userinfo.name && response.userinfo.identity_number) {
                // 已完善信息，设置为0（表示已完善）
                that.$store.commit('set_isRegister', 0);
              } else {
                // 未完善信息，设置为1（表示未完善）
                that.$store.commit('set_isRegister', 1);
              }
            }
          } else {
            // 如果接口返回-4，说明需要完善信息
            if (response.code == -4) {
              that.$store.commit('set_isRegister', 1);
            }
          }
        })
        .catch(function (error) {
          console.error('获取用户信息异常:', error);
        });
    },
    getLevelListFn: function () {
      let that = this;
      let url = "/mobile/levelText";
      let data = {};
      this.axios
        .post(url, data)
        .then((response) => {
          if (response.code == 0) {
            let list = [];
            response.level_list.forEach(function (item) {
              let obj = {
                key: item.level,
                value: item.title,
              };
              list.push(obj);
            });
            that.$store.commit("set_levelList", list);
          } else {
            // Toast({
            //   message: response.msg,
            //   duration: 3000,
            // });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {},
  watch: {},
};
</script>
